export default "__VITE_ASSET__DUwcJlDm__"